import { render, staticRenderFns } from "./BatchPriceConfig.vue?vue&type=template&id=40bb30f4&scoped=true"
import script from "./BatchPriceConfig.vue?vue&type=script&lang=js"
export * from "./BatchPriceConfig.vue?vue&type=script&lang=js"
import style0 from "./BatchPriceConfig.vue?vue&type=style&index=0&id=40bb30f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb30f4",
  null
  
)

export default component.exports